import { Flex, Switch, Tag, Tooltip, Typography, Space,Popconfirm } from "antd";
import { getTemplateTagColor } from "./templates";
import get from "lodash/get";
import {
  EditTwoTone,
  AudioMutedOutlined,
  AudioOutlined,
} from "@ant-design/icons";
import { COLOR_PRIMARY } from "..";
const { Text } = Typography;

export const companyTemplateColumns = (
  updatePauseStatus,
  toggleTemplateForm,
  updateNotificationStatus
) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Company",
    dataIndex: ["company", "name"],
    key: "company_name",
  },
  { title: "Reset Time", dataIndex: "reset_time", key: "reset_time" },
  {
    title: "Template Type",
    dataIndex: "type",
    key: "type",
    render: (type) => (
      <Tag color={getTemplateTagColor(get(type, "value"))}>
        <p>{get(type, "name")}</p>
      </Tag>
    ),
  },
  {
    title: "Last Synced",
    dataIndex: "last_synced",
    key: "last_synced",
    render: (lastSynced) => <Tag>{lastSynced}</Tag>,
  },
  {
    title: "Pause",
    key: "pause_status",
    dataIndex: "status",
    render: (status, record) => (
      <Flex justify="center" align="center">
        <Switch
          size="small"
          value={status}
          onChange={(value) => {
            updatePauseStatus(get(record, "id"), { status: value });
          }}
          checkedChildren={
            <Text className="text-white" style={{ fontSize: "10px" }}>
              Pause
            </Text>
          }
          unCheckedChildren={
            <Text className="text-white" style={{ fontSize: "10px" }}>
              Resume
            </Text>
          }
        />
      </Flex>
    ),
  },
  {
    title: "Actions",
    key: "actions",
    dataIndex: "actions",
    render: (_, record) => (
      <Space size="middle">
        <Tooltip title="Edit Company Template">
          <EditTwoTone
            style={{ fontSize: 20 }}
            twoToneColor={COLOR_PRIMARY}
            onClick={() => {
              toggleTemplateForm(record);
            }}
          />
        </Tooltip>
        {get(record, "company.notification_enabled") &&
          (get(record, "notification_enable") ? (
            <Popconfirm
              title="Mute template notification"
              description="Are you sure you want to mute notification?"
              onConfirm={() => {
                updateNotificationStatus(get(record, "id"), false);
              }}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Mute">
                <AudioOutlined
                  style={{ fontSize: 20, color: COLOR_PRIMARY }}
                  twoToneColor={COLOR_PRIMARY}
                />
              </Tooltip>
            </Popconfirm>
          ) : (
            <Popconfirm
              title="UnMute template notification"
              description="Are you sure you want to Unmute notification?"
              onConfirm={() => {
                updateNotificationStatus(get(record, "id"), true);
              }}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Unmute">
                <AudioMutedOutlined
                  style={{ fontSize: 20 }}
                  twoToneColor={COLOR_PRIMARY}
                />
              </Tooltip>
            </Popconfirm>
          ))}
      </Space>
    ),
  },
];
